export const analytics = {
  openDashboard: "Open as dashboard",
  allDashboards: "All dashboards",
  allHint: "All your accounts together. Pick one account to see its own numbers.",
  noAccounts: "Connect Instagram to see analytics",
  noAccountsHint: "Reach, views, best times to post and your audience appear here once an account is connected.",
  connect: "Connect Instagram",
  title: "Analytics",
  description: "How your content performs and who your audience is.",
  account: "Account",
  range: "Date range",
  ranges: {
    d7: "7 days",
    d28: "28 days",
    d90: "90 days",
  },
  metricTabs: "Metric",
  current: "This period",
  previous: "Previous period",
  noPrevious: "No previous period yet",
  totalIn: "Total in {{range}}",
  change: "Change",
  interactions: {
    title: "Interactions breakdown",
    description: "What people did with your content",
  },
  bestTimes: {
    title: "Best time to post",
    description: "Follower activity by weekday and hour ({{tz}})",
    suggestions: "Suggested slots",
    activity: "activity {{score}}/100",
    compose: "Schedule a post at this time",
  },
  demographics: {
    title: "Audience",
    description: "Where your followers are, and who they are",
    countries: "Top countries",
    cities: "Top cities",
    age: "Age",
    gender: "Gender",
    female: "Women",
    male: "Men",
    unknown: "Unspecified",
    empty: "Not enough followers yet: Instagram shows demographics from 100 followers.",
  },
  topPosts: {
    title: "Top posts",
    description: "Ranked by reach in this period",
    empty: "No posts published in this period",
    reach: "Reach",
    views: "Views",
    likes: "Likes",
    saves: "Saves",
    open: "Open post",
  },
  sentiment: {
    see: "{{sentiment}} comments",
    title: "Sentiment over time",
    description: "Comments by sentiment, per week",
    week: "Week of {{date}}",
    empty: "No comments yet",
  },
  export: "Export CSV",
  exported: "CSV downloaded",
  allAccountsNote: "Showing all accounts combined.",
  table: "Show as table",
  hideTable: "Hide table",
  date: "Date",
  error: "Couldn't load analytics",
};
